import { useEffect } from 'react';

/** Sets the document title for a route, restoring the previous one on unmount. */
export const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    const previous = document.title;
    document.title = title;

    return () => {
      document.title = previous;
    };
  }, [title]);
};
